import { SkeletonBox, SkeletonText } from '../primitives';
import '../primitives/Skeletons.css';

const FieldSkeleton = () => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
    <SkeletonText widths={['72px']} lineHeight="14px" />
    <SkeletonBox height={44} borderRadius="var(--radius-md)" />
  </div>
);

const AuthFormSkeleton = () => (
  <section
    aria-hidden="true"
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--space-md)',
      maxWidth: '420px',
      width: '100%',
      padding: 'clamp(1.25rem, 4vw, 2rem)',
      background: 'var(--color-surface)',
      borderRadius: '20px',
      border: '1px solid var(--color-border)',
      boxShadow: 'var(--shadow-md)',
    }}
  >
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '0.5rem' }}>
      <SkeletonText widths={['180px']} lineHeight="28px" />
      <SkeletonText widths={['260px']} lineHeight="14px" />
    </div>
    <FieldSkeleton />
    <FieldSkeleton />
    <SkeletonBox height={44} borderRadius="999px" style={{ marginTop: '0.25rem' }} />
    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', margin: '0.5rem 0' }}>
      <SkeletonBox width="100%" height={1} borderRadius="0" />
      <SkeletonText widths={['28px']} lineHeight="14px" />
      <SkeletonBox width="100%" height={1} borderRadius="0" />
    </div>
    <SkeletonBox height={44} borderRadius="var(--radius-md)" />
    <div style={{ display: 'flex', justifyContent: 'center', gap: '0.35rem', marginTop: '0.5rem' }}>
      <SkeletonText widths={['140px']} lineHeight="14px" />
      <SkeletonText widths={['72px']} lineHeight="14px" />
    </div>
  </section>
);

export default AuthFormSkeleton;
